
















import { Component, Vue } from 'nuxt-property-decorator';

import { IconArrowRight } from '@/icons';

@Component({
  components: {
    IconArrowRight,
  },
})
export default class ShowDateListItemSkeleton extends Vue {
  get linkIsEnabled () {
    return false;
  }
}
